import { render, staticRenderFns } from "./ViewFormPdi.vue?vue&type=template&id=58d19eae&scoped=true"
import script from "./ViewFormPdi.vue?vue&type=script&lang=js"
export * from "./ViewFormPdi.vue?vue&type=script&lang=js"
import style0 from "./ViewFormPdi.vue?vue&type=style&index=0&id=58d19eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d19eae",
  null
  
)

export default component.exports